export default __webpack_public_path__ + "static/media/Group 190.2f9ad2bf.svg";